import template from './login.html';
import './login.styl';

function loginController($rootScope, $state, $timeout, $tszToast, AuthService) {

  'ngInject';

  this.makeYourMagic = 'This is the login container';

  this.loading = false;
  this.error = '';
  this.data = {
    email: '',
    password: '',
  };

  if ($state.params.obj) {
    const params = $state.params.obj;
    if (params.email) {
      this.data.email = params.email;
    }

    if (params.toast) {
      const toast = params.toast;
      $tszToast.show(toast.message, toast.opts);
    }
  }

  this.login = (form) => {
    this.loading = true;

    if (form.$valid) {
      this.loading = true;
    }

    AuthService.login(this.data.email, this.data.password)
    .then((userData) => {

      console.log('Successful login!');

      const user = userData.data;

      // Store user data into the user service
      AuthService.setCredentials(user);

      $rootScope.$broadcast('authenticated', true);

      // login succeeded: redirect to the default page
      if (AuthService.isAdmin()) {
        $state.go('admin_home');
      } else {
        $state.go('home');
      }

    }).catch((err) => {
      // login error
      if (err.data && err.data.code) {
        $tszToast.showErrorI18n(err.data.code, 'El email o contraseña introducidos no son válidos');
      } else {
        $tszToast.showError('El email o contraseña introducidos no son válidos');
      }
    }).finally(() => {
      // regardless of the response, change the loading state
      this.loading = false;
    });

  };
}

export default {
  template,
  controller: loginController,
};



// WEBPACK FOOTER //
// ./src/containers/login/index.js